// @ts-nocheck
import React, { memo } from 'react';
import { Grid } from '@material-ui/core';
import { Form, Formik, FormikHelpers } from 'formik';

import Button from '../../elements/Button';
import { BUTTON_COLOR, BUTTON_SIZE, BUTTON_TYPE, BUTTON_VARIANT } from '../../enum/formProps';
import './FilterForm.scss';

interface FilterFormProps<T> {
  initialValues: T;
  validationSchema: object;
  onSubmit: (values: T, actions: FormikHelpers<T>) => void;
  disabled?: boolean;
}

function component<T>(props: React.PropsWithChildren<FilterFormProps<T>>) {
  return (
    <Formik
      initialValues={props.initialValues}
      onSubmit={props.onSubmit}
      validationSchema={props.validationSchema}
      enableReinitialize={true}
      validateOnChange={false}
    >
      <Form noValidate className="FilterForm-Wrapper">
        {props.children}
        <Grid container spacing={0} className="FilterForm-Container">
          <Grid item xs={4} md={3} lg={2} xl={1}></Grid>
          <Grid item xs={8} md={9} lg={10} xl={11}>
            <Button
              text="button.find"
              size={BUTTON_SIZE.LARGE}
              color={BUTTON_COLOR.PRIMARY}
              variant={BUTTON_VARIANT.CONTAINED}
              type={BUTTON_TYPE.SUBMIT}
              disabled={props.disabled}
            />
          </Grid>
        </Grid>
      </Form>
    </Formik>
  );
}

const FilterForm = memo(component) as typeof component;

export default FilterForm;
